import $ from 'jquery';
import styleSelect from 'styleselect';

$(document).ready(function() {
  const $select = $('.e-select');

  //
  $select.each(function() {
    const $thisSelect = $(this);
    const $innerSelects = $thisSelect.find('select');

    $innerSelects.each(function() {
      const select = $(this)[0];
      styleSelect(select);
    });
  });

});



// WEBPACK FOOTER //
// ./app/ui/elements/select/index.js